import React from 'react';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService';
import Badge from '@mui/material/Badge';
import BarChartIcon from '@mui/icons-material/BarChart';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import TuneIcon from '@mui/icons-material/Tune';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import AdminDashboard from './Dashboard/AdminDashboard.jsx';
import Orders from './Orders.jsx';
import Customers from './Customers.jsx';
import Recyclers from './Recyclers.jsx';
import Organizations from './Organizations.jsx';
import { GoogleMap, LoadScript, Data, DrawingManager, Circle, Polygon, LatLngBounds } from '@react-google-maps/api';

import './Admin.css';

const drawingLibraries = ['drawing']; // keep outside of component so it doesn't cause the map to re-render
const GOOGLE_MAPS_API_KEY = 'AIzaSyDqNnSuRDD3nyJ-oVOY4jV7McgqBIDyId0';

function Admin() {
    const [selectedTab, setSelectedTab] = React.useState('1');
    const [loggedInUser, setLoggedInUser] = React.useState(null);
    const [isFetching, setIsFetching] = React.useState(true);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [navigateData, setNavigateData] = React.useState(null);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    React.useEffect(() => {
        loadAccount(); // only called once

        let queryParams = new URLSearchParams(window.location.search);
        let orderParm = queryParams.get("Order");
        if (orderParm !== null) {
            setNavigateData({ tab: 'Orders', requestId: orderParm });
            setSelectedTab('4');
            let stateObj = { id: "100" };

            window.history.pushState(stateObj,
                "/Admin" + window.location.search, "/Admin");
        }

    }, []);

    function loadAccount() {
        
        TokenService.post('', 'Returner_MyAccount')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    if (typeof jsonData === 'string') {
                        jsonData = JSON.parse(jsonData);
                    }
                    let returnerData = jsonData.ReturnerData;
                    if (typeof returnerData === 'string') {
                        returnerData = JSON.parse(returnerData);
                    }
                    setLoggedInUser(returnerData);
                    sessionStorage.setItem('LoggedInUser', JSON.stringify(returnerData));
                    setIsFetching(false);

                    //let queryParams = new URLSearchParams(window.location.search);
                    //let orderParm = queryParams.get("Order");
                    //if (orderParm !== null) {
                    //    setNavigateData({ tab: 'Orders', requestId: orderParm });
                    //    setSelectedTab('4');
                    //}
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
      
    }

    return (
        <>
            <LoadScript
                googleMapsApiKey={GOOGLE_MAPS_API_KEY}
                libraries={drawingLibraries}
            >
                <TabContext value={selectedTab} >
                    <TabList
                        className="AdminTabHeader"
                        variant="fullWidth"
                        textColor="primary"
                        indicatorColor="secondary"
                        onChange={handleTabChange} aria-label="Admin Tabs">
                        <Tab style={{ fontWeight: 'bold' }}
                            label={<div className='AdminTab'><BarChartIcon className='AdminTabIcon' /><span className='AdminTabText'>Dashboard</span></div>}
                            value="1" />

                        <Tab style={{ fontWeight: 'bold' }}
                            label={<div className='AdminTab'><DirectionsCarIcon className='AdminTabIcon' /><span className='AdminTabText'>Recyclers</span></div>}
                            value="2" />

                        <Tab style={{ fontWeight: 'bold' }}
                            label={<div className='AdminTab'><PersonSearchIcon className='AdminTabIcon' /><span className='AdminTabText'>Clients</span></div>}
                            value="3" />

                        <Tab style={{ fontWeight: 'bold' }}
                            label={<div className='AdminTab'><ManageSearchIcon className='AdminTabIcon' /><span className='AdminTabText'>Orders</span></div>}
                            value="4" />

                        <Tab style={{ fontWeight: 'bold' }}
                            label={<div className='AdminTab'><TuneIcon className='AdminTabIcon' /><span className='AdminTabText'>Settings</span></div>}
                            value="5" />

                        <Tab style={{ fontWeight: 'bold' }}
                            label={<div className='AdminTab'><TravelExploreIcon className='AdminTabIcon' /><span className='AdminTabText'>Service Area</span></div>}
                            value="6" />

                        <Tab style={{ fontWeight: 'bold' }}
                            label={<div className='AdminTab'><VolunteerActivismIcon className='AdminTabIcon' /><span className='AdminTabText'>Orgs</span></div>}
                            value="7" />
                    </TabList>

                    <TabPanel value="1" style={{ padding: '10px' }}>
                        <AdminDashboard loggedInUser={loggedInUser} />
                    </TabPanel>
                    <TabPanel value="2" style={{ padding: '5px' }}>
                        <Recyclers loggedInUser={loggedInUser} />
                    </TabPanel>
                    <TabPanel value="3" style={{ padding: '10px' }}>
                        <Customers loggedInUser={loggedInUser} />
                    </TabPanel>

                    <TabPanel value="4" style={{ padding: '10px' }}>
                        <Orders navigationData={navigateData == null ? null : navigateData.tab != 'Orders' ? null : navigateData.requestId} loggedInUser={loggedInUser} />
                    </TabPanel>

                    <TabPanel value="5" style={{ padding: '10px' }}>
                        <div>Settings Panel</div>
                    </TabPanel>

                    <TabPanel value="6" style={{ padding: '10px' }}>
                        <div>Settings</div>
                    </TabPanel>

                    <TabPanel value="7" style={{ padding: '10px' }}>
                        <Organizations loggedInUser={loggedInUser} />
                    </TabPanel>
                </TabContext>
            </LoadScript>
        </>
    );
}

export default Admin;